import React, { useEffect } from "react";

// Store
import { pathTitles, useStore } from "../../Store/Store";
// Components
import { Loader, PageOverLay, TrainingInfo } from "..";

export const BTAdult = () => {
  const checkServices = useStore((state) => state.checkServices);
  const getLink = useStore((state) => state.getLink);
  const loading = useStore((state) => state.loading);
  const trainingDetails = useStore((state) => state.trainingDetails);

  useEffect(() => {
    checkServices(trainingDetails);
  }, []);
  const overlay = {
    where: "btAdult",
    title: "Board and Train for Adult Dogs",
    caption:
      "Chico (or Pez?) shows off his loose leash walking skills with a gentle leader.",
  };
  const info = {
    routes: {
      Home: "/",
      Training: getLink(pathTitles.TRAINING),
      "Board And Train": getLink(pathTitles.BOARDANDTRAIN),
      "Board And Train for Adult Dogs": getLink(pathTitles.BOARDANDTRAINADULT),
    },
    body: trainingDetails.BOARDANDTRAINADULT.body,
  };
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <PageOverLay overlay={overlay} />
          <TrainingInfo info={info} />
        </>
      )}
    </>
  );
};
